var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.326,
    height: 65.5,
    viewBox: "0 0 66.326 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_depart_2835079",
    transform: "translate(-109.481 -201.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(102.371 195.242)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 6.031,
    cy: 6.031,
    rx: 6.031,
    ry: 6.031,
    transform: "translate(49.326 17.683) rotate(-67.5)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M72.351,43.6l-7.912-5.328c-.581-1.611-1.959-6.1-3.188-8.729-1.328-2.838-4.247-3.389-8.021-4.187a7.419,7.419,0,0,0-7.108,2.563c-.038.044-.074.089-.109.134L33.662,43.364a2.774,2.774,0,0,0,.017,3.361L26.873,55.65l-4.977-3.8a2.12,2.12,0,0,0-2.962.4l-1.986,2.6-.316-.241a1.682,1.682,0,0,0-2.35.316l-6.7,8.783a1.682,1.682,0,0,0,.316,2.35l.316.241-.675.885a2.12,2.12,0,0,0,.4,2.962l3.415,2.6a3.7,3.7,0,0,1,7.262-1.186L28.048,59.2a2.112,2.112,0,0,0,.291-2.021l7.166-9.4A2.768,2.768,0,0,0,38.1,46.722L47.469,35.11l-3.087,9.832L42.04,60.136,34.827,71.278a2.894,2.894,0,0,0,.93,3.916,2.784,2.784,0,0,0,3.84-.854l7.618-11.617a2.8,2.8,0,0,0,.361-.858L49.863,51.13l9.012,9.176,2.456,13.056A2.781,2.781,0,0,0,66.8,72.334L64.642,58.37a2.778,2.778,0,0,0-.749-1.435l-9.685-10.67,2.935-12.147c1.189,3.069,2.312,6.739,2.326,6.779a2.783,2.783,0,0,0,.928,1.283l8.56,5.828A2.782,2.782,0,0,0,72.351,43.6Z",
    transform: "translate(0 -4.445)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 2.943,
    cy: 2.943,
    rx: 2.943,
    ry: 2.943,
    transform: "translate(11.071 66.819) rotate(-27.524)",
    fill: "#3b3b3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/checkOut.b1fcfc65da59b5e4f7522c41e4ebf230.svg";
export { ForwardRef as ReactComponent };